import { addLocaleData } from 'react-intl';
import ja from 'react-intl/locale-data/ja';

import { setTranslations as setNavTranslations } from '@99designs/globalnav/locale-data';
import navJa from '@99designs/globalnav/locale-data/ja';

setNavTranslations(navJa);
addLocaleData(ja);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/ja.js